import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BPTQuestionForm from '@/components/bpt/BPTQuestionForm.vue';
import BPTQuestionsSortingForm from '@/components/bpt/BPTQuestionsSortingForm.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import TranslatedState from '@/components/common/TranslatedState.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { BPTQuestion } from '@/models/bpt.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { BPTStoreActions, BPTStoreState } from '@/stores/bpt.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'BPTQuestions',
  setup(__props) {

const store = useStore<ShiftCMSState & { bpt: BPTStoreState }>();
const events = useEvents();

const questions = computed<BPTQuestion[]>(() => store.state.bpt.questions);

const update = () => {
  store.dispatch(BPTStoreActions.GetBPTQuestions);
};

onMounted(() => {
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Title', key: 'text', width: '50%' },
  { title: 'Type', key: 'type', width: '35%' },
  { title: 'Onboarding', key: 'onboarding', width: '5%' },
  { title: 'State', key: 'translated', sortable: false, width: '5%' },
];

const editQuestion = (_: Event, { item }: { item: BPTQuestion }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(BPTQuestionForm),
    data: item,
  });
};

const addQuestion = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(BPTQuestionForm),
  });
};

const sortQuestions = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(BPTQuestionsSortingForm),
    data: questions,
  });
};

const filterTitle = ref<string>('');
const filteredQuestions = computed(() =>
  questions.value.filter((v) =>
    filterTitle.value
      ? v.text.toLowerCase().indexOf(filterTitle.value.toLowerCase()) !== -1
      : true,
  ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterTitle.value = filters.filterTitle;
}

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode("Behavior & Profile Tracker ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(ListFilter, { onFilter: updateFilter }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: filteredQuestions.value.sort((a, b) => a.index - b.index),
        "onClick:row": editQuestion,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.onboarding": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value ? 'Yes' : 'No'), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createVNode(TranslatedState, { item: item }, null, 8, ["item"])
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addQuestion,
        color: "success",
        class: "mr-4"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Add Question")
        ])),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: sortQuestions,
        color: "success"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Sort and Hierarchy")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})